<template>
  <article class="modal">
    <div class="conduct-button-cont ui-link-alt" @click="closeModal">
      close
    </div>

    <h2 class="modal__item">Conference Code of Conduct</h2>
    <strong class="modal__item">
      All attendees, speakers, staff, sponsors and volunteers are expected to comply with the following code of conduct to ensure a safe and pleasant environment for everyone.
    </strong>
    <p class="modal__item modal__item--margin">
      Awwwards is dedicated to providing a harassment-free experience for everyone attending or participating in the Awwwards conference. We will not tolerate harassment of or discrimination against anyone, regardless of gender, race, religion, age, sexual orientation, disability or physical appearance. Harassment can include offensive comments, disruptive behaviour during conference sessions, physical intimidation, stalking, following, photographing or recording an unwilling participant, inappropriate physical contact and unwelcome sexual attention.
      Sexualised language or imagery is not appropriate in presentations, exhibit stands, workshops or discussions (on or offline) at the conference and will not be permitted.
      Harassment of conference participants online or in electronic venues will be treated as seriously as physical harassment. If you aren’t sure what constitutes harassment, err on the side of caution and restrict your contact.
      Anyone engaging in harassing behaviour will be asked to stop immediately. We reserve the right to dismiss anyone from the conference without a refund for failure to comply with our anti-harassment policy.
      If you are being harassed or notice someone else being harassed, please contact a member of the Awwwards staff. We will be happy to assist in contacting the appropriate authorities as necessary and providing support to ensure anyone on the receiving end of these behaviours feels safe for the duration of the conference.
    </p>
    <p class="modal__item modal__item--margin">
      <strong>NEED HELP? HERE’S HOW TO CONTACT US.</strong>
    </p>
    <p class="modal__item">
      During the Awwwards conference, you can find a member of the Awwwards team at all times at the registration desk. Please come and talk to us if you need assistance or if there’s anything we can do to help improve your experience of the event. You can also reach us at any time on Twitter <a class="ui-link" data-hover="@Awwwards" href="https://twitter.com/awwwards" target="_blank" rel="noopener">@Awwwards</a>, and via email at <a class="ui-link" data-hover="awwwards@awwwards.com" href="mailto:awwwards@awwwards.com">awwwards@awwwards.com</a>.
    </p>
  </article>
</template>

<script>
export default {
  name: 'modalConduct',

  props: {
    closeModal: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  bottom: -2px;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 1380px;
  max-height: 80vh;
  max-height: calc(var(--vh, 1vh) * 80);
  margin: 0 auto;
  padding: 50px 25px;

  box-sizing: border-box;

  background-color: #ffffff;
  border: 1px solid $color-text;
  border-bottom: transparent;

  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: z-index(modal);

  @include mq(ipadP) {
    padding: 50px 50px;
  }

  h2 {
    font-size: 2.25rem;
    margin-bottom: 1.25rem;
    color: $color-pink;
  }

  p {
    position: relative;
    margin: 0;
    padding: 0;
  }

  a {
    position: relative;
  }

  .modal__item--margin {
    margin-top: 20px;
  }

  .conduct-button-cont {
    position: absolute;
    top: 20px;
    right: 25px;
    box-sizing: border-box;
    margin-top: 2px;
    background-color: #F5F7FA;

    cursor: pointer;
  }
}
</style>
